import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './successMessage.css';

class successMessage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            messageHidden: true,
        };
    }

    componentDidMount () {
        setTimeout(() => {
            this.setState(
                {
                    messageHidden: false,
                },
                () => {
                    setTimeout(() => {
                        this.setState(
                            {
                                messageHidden: true,
                            },
                            () => {
                                setTimeout(() => {
                                    this.props.resetSuccessMessage();
                                }, 200);
                            }
                        );
                    }, 2700);
                }
            );
        }, 200);
    }

    render () {
        return (
            <div className={`success-message-container ${this.state.messageHidden ? '' : 'display-success-message'}`}>
                <p className="success-message-text">{this.props.message}</p>
            </div>
        );
    }
}

successMessage.propTypes = {
    message: PropTypes.string,
    resetSuccessMessage: PropTypes.func,
};

export default successMessage;
